/**
 * Filter Category Heading Component
 *
 * Collapsible section header for filter categories.
 * Figma: Category Heading (Node: 358:18216)
 *
 * Height: ~42px
 * Features: Label, expand/collapse chevron, optional select all/clear links
 */
"use client";

import Image from "next/image";

import { colors } from "@/styles/design-tokens";

interface FilterCategoryHeadingProps {
  label: string;
  isExpanded: boolean;
  onToggle: () => void;
  showSelectOptions?: boolean;
  onSelectAll?: () => void;
  onClear?: () => void;
  className?: string;
  accentColor?: string; // Optional accent color for the label
}

export function FilterCategoryHeading({
  label,
  isExpanded,
  onToggle,
  showSelectOptions = false,
  onSelectAll,
  onClear,
  className = "",
  accentColor,
}: FilterCategoryHeadingProps) {
  return (
    <div
      className={className}
      style={{
        width: "100%",
        height: "41.974px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Left side: Label with optional select options */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          paddingTop: "14.121px",
        }}
      >
        {/* Main label */}
        <span className="text-tag-caps" style={{ color: accentColor || colors.text.accentMdGray }}>
          {label}
        </span>

        {/* Optional select all / clear links */}
        {showSelectOptions && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                onSelectAll?.();
              }}
              className="text-tag-caps text-ink-secondary cursor-pointer border-none bg-transparent p-0 lowercase"
            >
              select all
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClear?.();
              }}
              className="text-tag-caps text-ink-secondary cursor-pointer border-none bg-transparent p-0 lowercase"
            >
              clear
            </button>
          </div>
        )}
      </div>

      {/* Right side: Chevron/Dropdown icon */}
      <button
        onClick={onToggle}
        style={{
          width: "14px",
          height: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          background: "none",
          border: "none",
          padding: 0,
          marginTop: "14.999px",
        }}
      >
        <Image
          src={isExpanded ? "/icons/dropdown.svg" : "/icons/chevron.svg"}
          alt=""
          width={14}
          height={14}
        />
      </button>
    </div>
  );
}
